
import { Vue, Prop, Component } from 'vue-property-decorator';
import Passenger from '@/components/Passenger/models/Passenger';
import PassengerSearch from '@/components/PassengerSearch.vue';
import PassengerInformationCard from '@/components/Organization/AddPassengerToPassengerGroup/PassengerInformationCard.vue';
import { IPassengerGroupWithPassengers, IPassengerSearchResult } from '@/typings/timit';

@Component({
  components: {
    PassengerSearch,
    PassengerInformationCard,
  },
})
export default class AddPassengerToPassengerGroupForm extends Vue {
  selectedPassenger: Passenger | null = null;

  @Prop({ required: true }) passengerGroup: IPassengerGroupWithPassengers;

  get existingPassengerIds() {
    if (!this.passengerGroup || !this.passengerGroup.passengerGroupPassengers) {
      return [];
    }
    return this.passengerGroup.passengerGroupPassengers.map(p => p.id);
  }

  async onPassengerSelect(passenger: IPassengerSearchResult) {
    let selectedPassenger = null;

    if (passenger) {
      const result = await this.$store.dispatch('passenger/getPassengerById', {
        params: { id: passenger.id }
      });
      selectedPassenger = new Passenger(result.data);
    }
    this.selectedPassenger = selectedPassenger;
  }

  close() {
    this.selectedPassenger = null;
    this.$emit('close');
  }

  save() {
    this.$emit('save', this.selectedPassenger);
    this.selectedPassenger = null;
  }
}
